import React, { useRef, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import cx from 'classnames';
import { ReactComponent as Dots } from '../../assets/img/icons/common/Dots.svg';
import { useHandleOutsideClick } from '../../hooks/useHandleOutsideClick';

const AIAssistantDropDown = ({ options }) => {
  const dropdownRef = useRef(null);
  const [showDropDown, setShowDropDown] = useState(false);

  const onClick = event => {
    event.stopPropagation();
    setShowDropDown(!showDropDown);
  };
  
  useHandleOutsideClick(showDropDown, () => setShowDropDown(false), dropdownRef);

  return (
    <Dropdown ref={dropdownRef} show={showDropDown} className={cx('table-dropdown ai-assistant-dropdown')}>
      <Dropdown.Toggle onClick={onClick}>
        <Dots />
      </Dropdown.Toggle>

      <Dropdown.Menu renderOnMount popperConfig={{ strategy: 'fixed' }}>
        {options.map((option, index) => (
          <Dropdown.Item
            key={index}
            disabled={!!option.disabled}
            onClick={event => {
              event.stopPropagation();
              option.onClick && option.onClick(event);
              setShowDropDown(false);
            }}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AIAssistantDropDown;
